import messages from "messages";
import styles from "./styles.module.scss";
import PlanFieldLabel from "../plan-field-label";

type Props = {
  className?: string;
  code: { id: string; description?: string; [key: string]: any };
};
const DiagnosisCode = ({ className, code }: Props) => (
  <div className={className}>
    <PlanFieldLabel label={messages.diagnosisCode} readOnly={false} />
    <div className={styles["diagnosis-code__code"]}>
      <span>{code.id}</span>
      <span className={styles["diagnosis-code__info"]}>{code.description}</span>
    </div>
  </div>
);

export default DiagnosisCode;
